import _ from 'lodash';
import classnames from 'classnames';
import createReactClass from 'create-react-class';
import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import VirtualizedSelect from 'react-virtualized-select';
import TimerMixin from 'react-timer-mixin';

import { scrollLockCore } from 'components/lib/util/scroll_lock_handler';

/* SelectGroups is a wrapper around VirtualizedSelect which allows for the grouping of select
 * options with a header. From https://github.com/JedWatson/react-select/issues/59
 */

const SelectGroups = createReactClass({
  mixins: [TimerMixin],

  propTypes: {
    autoFocus: PropTypes.bool,
    backspaceRemoves: PropTypes.bool,
    className: PropTypes.string,
    clearable: PropTypes.bool,
    disabled: PropTypes.bool,
    filterOptions: PropTypes.func,
    name: PropTypes.string,
    placeholder: PropTypes.string,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    // Unlike ReactSelect, this expects a 2-layer structure like:
    //  [ { label: 'Hidden Options', children: options, hidden: true }, ...]
    options: PropTypes.array.isRequired,
    searchPromptText: PropTypes.string,
    value: PropTypes.string,
  },

  getInitialState() {
    return {
      options: this.transformOptions(this.props.options),
    };
  },

  componentDidMount() {
    if (this.props.autoFocus) {
      this.focus();
    }

    // override virtual select's keydown handler
    this._handleKeyDown = this.select._selectRef.handleKeyDown;
    this.select._selectRef.handleKeyDown = this.handleKeyDown;
  },

  handleKeyDown(event) {
    this._handleKeyDown(event);

    let s = this.select._selectRef;
    if (s.props.disabled) return;

    if (typeof s.props.onInputKeyDown === 'function') {
      s.props.onInputKeyDown(event);
      if (event.defaultPrevented) {
        return;
      }
    }

    if (event.keyCode === 27) {
      s.input.blur();
    }
  },

  handleClose() {
    this.select._selectRef.setState({ focusedOption: undefined });
  },

  UNSAFE_componentWillReceiveProps(newProps) {
    this.setState({
      options: this.transformOptions(newProps.options),
    });
  },

  onChange(value) {
    this.props.onChange(value);
    this.select._selectRef.setState({ focusedOption: undefined });
  },

  handleWheel(ev) {
    let menuNode = ReactDOM.findDOMNode(this.select).querySelector('.VirtualSelectGrid');
    if (menuNode) {
      ev.stopPropagation();
      scrollLockCore(ev, menuNode);
    }
  },

  focus() {
    if (this.select) {
      this.select.focus();
    }
  },

  render() {
    return (
      <div className="selectGroup-wrapper" onWheel={this.handleWheel}>
        <VirtualizedSelect
          autoBlur
          backspaceRemoves={this.props.backspaceRemoves}
          className={this.props.className}
          clearable={this.props.clearable}
          disabled={this.props.disabled}
          filterOptions={this.filterOptions}
          matchProp="label"
          name={this.props.name}
          onChange={this.onChange}
          onInputChange={this.handleInputChange}
          onFocus={this.props.onFocus}
          onClose={this.handleClose}
          openOnFocus
          optionRenderer={this.renderOption}
          options={this.state.options}
          placeholder={this.props.placeholder}
          ref={select => {
            this.select = select;
          }}
          searchPromptText={this.props.searchPromptText}
          value={this.props.value}
          valueRenderer={this.renderValue}
          optionHeight={({ option }) => (option.children ? 28 : 52)}
        />
      </div>
    );
  },

  handleInputChange(value) {
    if (this.select) {
      let selectRef = this.select._selectRef;
      let firstOption = _.find(selectRef._visibleOptions, option => !option.disabled);
      selectRef.setState({ focusedOption: firstOption });
      return value;
    }
  },

  filterOptions(options, term, currentValues) {
    let almostReadyOptions = this.props.filterOptions
      ? this.props.filterOptions(options, term, currentValues)
      : _.filter(options, o => (o.parent ? _.includes(o.label.toLowerCase(), term.toLowerCase()) : true));
    let optionsGroupByParent = _.groupBy(almostReadyOptions, o => _.get(o, 'parent.label'));
    // Filter empty parents
    let readyOptions = _.filter(almostReadyOptions, option =>
      option.parent ? option : _.size(optionsGroupByParent[option.value]) > 0
    );
    let visibleOptions = _.filter(readyOptions, option => option.hidden !== true);
    this.prevTerm = term;
    this.prevOptions = visibleOptions;
    return visibleOptions;
  },

  transformOptions(options) {
    return _.reduce(
      options,
      (res, el) => {
        let parent = option(el.label, el.label, true, el.hidden, el);
        let children = _.map(el.children, child => {
          let rest = _.omit(child, ['value', 'label', 'hidden', 'disabled']);
          return option(child.value, child.label, false, el.hidden, { ...rest, parent });
        });
        return res.concat(parent).concat(children);
      },
      []
    );
  },

  renderOption(opts) {
    // if you want to render your own custom option for a group of options
    // attach a `renderChildOption` to the parent of the children
    if (typeof _.get(opts, 'option.parent.renderChildOption') === 'function') {
      return opts.option.parent.renderChildOption(opts);
    }

    const { style, focusedOption, option, valueArray, key, selectValue, focusOption } = opts;
    const inner = option.children ? this.renderParentInner(option) : this.renderChildInner(option);
    const classNames = classnames('Select-option', {
      'is-focused': option === focusedOption,
      'is-selected': _.includes(valueArray, option),
      'Select-option-header': option.children,
    });

    return (
      <div
        className={classNames}
        key={key}
        style={style}
        onClick={option.children ? _.noop : () => selectValue(option)}
        onMouseEnter={() => focusOption(option)}
      >
        {inner}
      </div>
    );
  },

  renderValue(option) {
    let isOpen = _.get(this, 'select._selectRef.state.isOpen');
    if (isOpen) {
      return <div className="Select-option-search">Type to search</div>;
    }
    return option.label;
  },

  renderParentInner(option) {
    return <span className="Select-option-header-label">{option.label}</span>;
  },

  renderChildInner(option) {
    let sublabel = option.sublabel ? <span className="Select-option-sublabel">{option.sublabel}</span> : null;
    return (
      <div>
        <span className="Select-option-label">{option.label}</span>
        {sublabel}
      </div>
    );
  },
});

export function option(value, label, disabled = false, hidden = false, rest = {}) {
  return { value, label, disabled, hidden, ...rest };
}

export default SelectGroups;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/lib/select_groups.jsx